import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/security/users/${resource.id}/edit`} />,
    <MenuItem primaryText='Groups' key='groups' value={`/write-now/members?filters[user_id]=${resource.id}`} />,
    <MenuItem primaryText='Impersonate' key='impersonate' value={`/security/users/${resource.id}/impersonate`} />
  ]
}

export default buildMenuItems
